import React, { useCallback, useEffect, useState } from 'react';
import { fetchMyPhones, setPrimaryPhone } from '../../api/profileExtras';
import './ProfilePhonesModal.css';

function formatPhone(row) {
  const cc = (row.country_code || '').trim();
  const pl = (row.phone_local || '').trim();
  return cc ? `${cc} ${pl}` : pl;
}

export default function ProfilePhonesModal({
  token,
  onClose,
  onAddTelegramPhone,
  onPrimaryChanged,
}) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [confirmChangeOpen, setConfirmChangeOpen] = useState(false);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const json = await fetchMyPhones(token);
      setData(json);
    } catch {
      setError('Не удалось загрузить номера');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const onSelectPrimary = async (phoneId) => {
    if (!token || saving) return;
    setSaving(true);
    setError(null);
    try {
      await setPrimaryPhone(token, phoneId);
      await load();
      onPrimaryChanged?.();
    } catch {
      setError('Не удалось сменить основной номер');
    } finally {
      setSaving(false);
    }
  };

  const onPlusClick = () => {
    if (!data?.has_telegram_login) return;
    if (data?.has_telegram_phone) {
      setConfirmChangeOpen(true);
      return;
    }
    onAddTelegramPhone?.();
  };

  const confirmYes = () => {
    setConfirmChangeOpen(false);
    onAddTelegramPhone?.();
  };

  return (
    <div className="profile-phones-modal__backdrop" role="presentation" onClick={onClose}>
      <div
        className="profile-phones-modal__dialog"
        role="dialog"
        aria-labelledby="profile-phones-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="profile-phones-title" className="profile-phones-modal__title">
          Номера телефонов
        </h2>
        {loading ? <p className="profile-phones-modal__muted">Загрузка…</p> : null}
        {error ? <p className="profile-phones-modal__err">{error}</p> : null}
        {!loading && data?.phones?.length === 0 ? (
          <p className="profile-phones-modal__muted">Нет сохранённых номеров</p>
        ) : null}
        <ul className="profile-phones-modal__list">
          {(data?.phones || []).map((row) => (
            <li key={row.id} className="profile-phones-modal__item">
              <button
                type="button"
                className={`profile-phones-modal__row${row.is_primary ? ' profile-phones-modal__row--active' : ''}`}
                onClick={() => !row.is_primary && onSelectPrimary(row.id)}
                disabled={saving || row.is_primary}
              >
                <span className="profile-phones-modal__number">{formatPhone(row)}</span>
                <span className="profile-phones-modal__platforms">
                  {(row.verified_platforms || []).join(', ')}
                </span>
                {row.is_primary ? (
                  <span className="profile-phones-modal__badge">Основной</span>
                ) : (
                  <span className="profile-phones-modal__action">Сделать основным</span>
                )}
              </button>
            </li>
          ))}
        </ul>
        {data?.has_telegram_login ? (
          <button type="button" className="profile-phones-modal__add" onClick={onPlusClick}>
            + Добавить через Telegram
          </button>
        ) : null}
        <button type="button" className="profile-phones-modal__close" onClick={onClose}>
          Закрыть
        </button>
      </div>

      {confirmChangeOpen ? (
        <div className="profile-phones-modal__confirm-backdrop" role="presentation">
          <div className="profile-phones-modal__confirm" role="alertdialog">
            <p className="profile-phones-modal__confirm-text">
              Номер из Telegram уже есть в профиле. Номер изменился?
            </p>
            <div className="profile-phones-modal__confirm-actions">
              <button type="button" className="profile-phones-modal__confirm-btn" onClick={() => setConfirmChangeOpen(false)}>
                Нет
              </button>
              <button type="button" className="profile-phones-modal__confirm-btn profile-phones-modal__confirm-btn--primary" onClick={confirmYes}>
                Да
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
